var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.222 412.519C251.486 412.519 249.866 412.056 248.361 411.246L232.969 402.103C230.654 400.83 231.811 400.367 232.506 400.136C235.631 399.094 236.209 398.863 239.45 397.011C239.797 396.78 240.26 396.895 240.607 397.127L252.412 404.186C252.875 404.418 253.453 404.418 253.801 404.186L299.978 377.452C300.441 377.221 300.672 376.758 300.672 376.179V322.827C300.672 322.248 300.441 321.785 299.978 321.553L253.801 294.935C253.338 294.704 252.759 294.704 252.412 294.935L206.235 321.553C205.772 321.785 205.54 322.364 205.54 322.827V376.179C205.54 376.642 205.772 377.221 206.235 377.452L218.849 384.743C225.678 388.215 229.96 384.165 229.96 380.114V327.456C229.96 326.761 230.538 326.067 231.349 326.067H237.251C237.945 326.067 238.64 326.646 238.64 327.456V380.114C238.64 389.257 233.663 394.581 224.983 394.581C222.321 394.581 220.238 394.581 214.336 391.687L202.184 384.743C199.175 383.007 197.323 379.767 197.323 376.295V322.942C197.323 319.47 199.175 316.23 202.184 314.494L248.361 287.76C251.255 286.139 255.189 286.139 258.083 287.76L304.26 314.494C307.269 316.23 309.121 319.47 309.121 322.942V376.295C309.121 379.767 307.269 383.007 304.26 384.743L258.083 411.478C256.578 412.172 254.842 412.519 253.222 412.519ZM267.457 375.832C247.204 375.832 243.038 366.573 243.038 358.704C243.038 358.009 243.616 357.315 244.426 357.315H250.444C251.139 357.315 251.717 357.778 251.717 358.472C252.643 364.606 255.305 367.615 267.573 367.615C277.294 367.615 281.461 365.416 281.461 360.208C281.461 357.199 280.303 355 265.142 353.496C252.528 352.223 244.658 349.445 244.658 339.376C244.658 330.002 252.528 324.447 265.721 324.447C280.535 324.447 287.826 329.539 288.752 340.649C288.752 340.997 288.636 341.344 288.405 341.691C288.173 341.922 287.826 342.154 287.479 342.154H281.461C280.882 342.154 280.303 341.691 280.188 341.112C278.799 334.747 275.211 332.664 265.721 332.664C255.074 332.664 253.801 336.367 253.801 339.145C253.801 342.501 255.305 343.543 269.656 345.394C283.891 347.246 290.604 349.908 290.604 359.861C290.488 370.045 282.155 375.832 267.457 375.832Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.946 203.853C109.946 201.77 108.788 199.803 106.937 198.761L57.8662 170.523C57.0561 170.06 56.1302 169.828 55.2043 169.712H54.7414C53.8156 169.712 52.8897 170.06 52.0796 170.523L3.00904 198.761C1.15732 199.803 0 201.77 0 203.853L0.115732 279.774C0.115732 280.815 0.694394 281.857 1.62025 282.32C2.54611 282.899 3.70344 282.899 4.51356 282.32L33.6781 265.655C35.5298 264.613 36.6872 262.646 36.6872 260.562V225.032C36.6872 222.949 37.8445 220.982 39.6962 219.94L52.0796 212.765C53.0054 212.186 54.047 211.955 55.0886 211.955C56.1302 211.955 57.1718 212.186 57.9819 212.765L70.3653 219.94C72.217 220.982 73.3743 222.949 73.3743 225.032V260.562C73.3743 262.646 74.5317 264.613 76.3834 265.655L105.548 282.32C106.474 282.899 107.631 282.899 108.557 282.32C109.483 281.857 110.062 280.815 110.062 279.774L109.946 203.853V203.853V203.853Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.808 99.3472C344.882 98.8843 343.725 98.8843 342.915 99.3472C341.989 99.9259 341.41 100.852 341.41 101.893V177.119C341.41 177.814 341.063 178.508 340.368 178.971C339.674 179.318 338.98 179.318 338.285 178.971L326.018 171.911C324.166 170.87 321.967 170.87 320.115 171.911L271.045 200.266C269.193 201.307 268.036 203.275 268.036 205.358V261.951C268.036 264.034 269.193 266.002 271.045 267.043L320.115 295.398C321.967 296.439 324.166 296.439 326.018 295.398L375.088 267.043C376.94 266.002 378.097 264.034 378.097 261.951V120.873C378.097 118.675 376.94 116.707 375.088 115.665L345.808 99.3472V99.3472V99.3472ZM341.294 243.318C341.294 243.897 341.062 244.36 340.599 244.591L323.818 254.313C323.355 254.544 322.777 254.544 322.314 254.313L305.533 244.591C305.07 244.36 304.838 243.781 304.838 243.318V223.875C304.838 223.297 305.07 222.834 305.533 222.602L322.314 212.881C322.777 212.649 323.355 212.649 323.818 212.881L340.599 222.602C341.062 222.834 341.294 223.412 341.294 223.875V243.318V243.318V243.318Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.107 223.413C510.958 222.371 512 220.403 512 218.32V204.548C512 202.465 510.843 200.498 509.107 199.456L460.383 171.217C458.532 170.176 456.333 170.176 454.481 171.217L405.41 199.572C403.559 200.613 402.401 202.581 402.401 204.664V261.257C402.401 263.34 403.559 265.308 405.41 266.349L454.134 294.125C455.985 295.167 458.184 295.167 459.92 294.125L489.432 277.691C490.358 277.228 490.937 276.187 490.937 275.145C490.937 274.103 490.358 273.062 489.432 272.599L440.13 244.244C439.204 243.666 438.626 242.74 438.626 241.698V223.991C438.626 222.95 439.204 221.908 440.13 221.445L455.523 212.649C456.448 212.071 457.606 212.071 458.532 212.649L473.924 221.445C474.85 222.024 475.429 222.95 475.429 223.991V237.879C475.429 238.921 476.007 239.962 476.933 240.425C477.859 241.004 479.016 241.004 479.942 240.425L509.107 223.413V223.413V223.413Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.68 220.751C457.027 220.519 457.49 220.519 457.837 220.751L467.211 226.19C467.558 226.422 467.79 226.769 467.79 227.232V238.111C467.79 238.574 467.558 238.921 467.211 239.152L457.837 244.592C457.49 244.823 457.027 244.823 456.68 244.592L447.305 239.152C446.958 238.921 446.727 238.574 446.727 238.111V227.232C446.727 226.769 446.958 226.422 447.305 226.19L456.68 220.751V220.751V220.751Z",
    fill: "#539E43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 171.449C190.148 170.407 187.949 170.407 186.098 171.449L137.374 199.572C135.523 200.613 134.481 202.581 134.481 204.664V261.026C134.481 263.109 135.638 265.076 137.374 266.118L186.098 294.241C187.949 295.282 190.148 295.282 192 294.241L240.723 266.118C242.575 265.076 243.617 263.109 243.617 261.026V204.664C243.617 202.581 242.459 200.613 240.723 199.572L192 171.449V171.449V171.449Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 171.449C190.148 170.407 187.949 170.407 186.098 171.449L137.374 199.572C135.523 200.613 134.481 202.581 134.481 204.664V261.026C134.481 263.109 135.638 265.076 137.374 266.118L186.098 294.241C187.949 295.282 190.148 295.282 192 294.241L240.723 266.118C242.575 265.076 243.617 263.109 243.617 261.026V204.664C243.617 202.581 242.459 200.613 240.723 199.572L192 171.449V171.449V171.449Z",
    fill: "url(#paint0_linear_2705_178)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2705_178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 170,
    width: 110,
    height: 126
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 171.449C190.148 170.407 187.949 170.407 186.098 171.449L137.374 199.572C135.523 200.613 134.481 202.581 134.481 204.664V261.026C134.481 263.109 135.638 265.076 137.374 266.118L186.098 294.241C187.949 295.282 190.148 295.282 192 294.241L240.723 266.118C242.575 265.076 243.617 263.109 243.617 261.026V204.664C243.617 202.581 242.459 200.613 240.723 199.572L192 171.449V171.449V171.449Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2705_178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.84 199.572L191.885 171.449C191.422 171.217 190.844 170.986 190.381 170.87L135.523 264.845C135.986 265.423 136.565 265.886 137.144 266.234L186.098 294.357C187.487 295.167 189.108 295.398 190.612 294.935L242.113 200.729C241.766 200.266 241.303 199.919 240.84 199.572V199.572V199.572Z",
    fill: "url(#paint1_linear_2705_178)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2705_178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 170,
    width: 110,
    height: 126
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 171.449C190.148 170.407 187.949 170.407 186.098 171.449L137.374 199.572C135.523 200.613 134.481 202.581 134.481 204.664V261.026C134.481 263.109 135.638 265.076 137.374 266.118L186.098 294.241C187.949 295.282 190.148 295.282 192 294.241L240.723 266.118C242.575 265.076 243.617 263.109 243.617 261.026V204.664C243.617 202.581 242.459 200.613 240.723 199.572L192 171.449V171.449V171.449Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2705_178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.955 266.118C242.344 265.308 243.385 263.919 243.848 262.414L190.148 170.754C188.76 170.523 187.255 170.639 185.982 171.449L137.375 199.456L189.801 295.051C190.496 294.935 191.306 294.704 192 294.356L240.955 266.118V266.118V266.118Z",
    fill: "url(#paint2_linear_2705_178)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.955 266.118L192.116 294.241C191.422 294.588 190.727 294.82 189.917 294.935L190.843 296.671L245.006 265.308V264.613L243.617 262.299C243.385 263.919 242.344 265.308 240.955 266.118V266.118V266.118Z",
    fill: "url(#paint3_linear_2705_178)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.955 266.118L192.116 294.241C191.422 294.588 190.727 294.82 189.917 294.935L190.843 296.671L245.006 265.308V264.613L243.617 262.299C243.385 263.919 242.344 265.308 240.955 266.118V266.118V266.118Z",
    fill: "url(#paint4_linear_2705_178)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2705_178",
    x1: 178.525,
    y1: 176.606,
    x2: 126.662,
    y2: 239.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2705_178",
    x1: 210.446,
    y1: 309.82,
    x2: 340.18,
    y2: 257.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2705_178",
    x1: 132.702,
    y1: 298.71,
    x2: 245.445,
    y2: 298.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2705_178",
    x1: 132.702,
    y1: 314.753,
    x2: 245.445,
    y2: 314.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2705_178",
    x1: 121.082,
    y1: 181.304,
    x2: 110.452,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/Nodejs.6f0d2cb3b69d1bd786ab6be4a8a5cf73.svg";
export { ForwardRef as ReactComponent };